import script from "./IpInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IpInfo.vue?vue&type=script&setup=true&lang=js"

import "./IpInfo.vue?vue&type=style&index=0&id=94180af6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94180af6"]])

export default __exports__